export { default } from './LazyBootcamps';
